import { __awaiter } from "tslib";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { isObject, mergeObjects, } from "@rjsf/utils";
import _omit from "lodash/omit";
import _get from "lodash/get";
import _set from "lodash/set";
import _isEqual from "lodash/isEqual";
import _pick from "lodash/pick";
import _toPath from "lodash/toPath";
import _cloneDeep from "lodash/cloneDeep";
import _uniqWith from "lodash/uniqWith";
import _ from "lodash";
import { reSequenceFormEntitiesOnDeletion } from './dndUtils';
import { translateError } from './validationTranslator';
import Form from "./Form";
console.log('@fo-rjsf build 5.12.0-rc4 - 2023/08/25 12:30');
const OperationType = {
    ADD: 'add',
    DELETE: 'delete',
    ORDER: 'order',
    EDIT: 'edit',
    CANCEL: 'cancel',
    SUBMIT: 'submit',
};
const idToPropertyPath = (id, idPrefix) => {
    let path = id;
    path = path === null || path === void 0 ? void 0 : path.replace(/_(\d+)_/g, '[$1].');
    path = path === null || path === void 0 ? void 0 : path.replace(/_/g, '.');
    path = path === null || path === void 0 ? void 0 : path.replace(/\.$/g, '');
    path = path === null || path === void 0 ? void 0 : path.replace(idPrefix, '');
    path = path === null || path === void 0 ? void 0 : path.substring(1);
    return path;
};
function getAsPropertySchema(property) {
    return property === null || property === void 0 ? void 0 : property.replace(/\[(\d+)\]/, '.$1');
}
function isErrorEqual(err1, err2) {
    const props = ['message', 'name', 'property'];
    return _isEqual(_pick(err1, props), _pick(err2, props));
}
/** The `Form` component renders the outer form and all the fields defined in the `schema` */
export default class FoForm extends Form {
    constructor(props) {
        super(props);
        this.onChange = (formData, newErrorSchema, id) => {
            const { extraErrors, omitExtraData, liveOmit, noValidate, liveValidate, onChange } = this.props;
            const { schemaUtils, schema } = this.state;
            if (isObject(formData) || Array.isArray(formData)) {
                // TODO here to pass the list of preserved fields
                const newState = this.getStateFromProps(this.props, formData);
                formData = newState.formData;
            }
            // trigger liveValidate only for simple fields
            const idSchemaPath = idToPropertyPath(id, this.props.idPrefix, this.props.idSeparator);
            const part = _get(formData, idSchemaPath);
            if (!isObject(part) && !Array.isArray(part)) {
                this.debouncedPartialValidate(id);
            }
            const mustValidate = !noValidate && liveValidate;
            let state = { formData, schema };
            let newFormData = formData;
            if (omitExtraData === true && liveOmit === true) {
                const retrievedSchema = schemaUtils.retrieveSchema(schema, formData);
                const pathSchema = schemaUtils.toPathSchema(retrievedSchema, '', formData);
                const fieldNames = this.getFieldNames(pathSchema, formData);
                newFormData = this.getUsedFormData(formData, fieldNames);
                state = {
                    formData: newFormData,
                };
            }
            if (mustValidate) {
                const schemaValidation = this.validate(newFormData);
                let errors = schemaValidation.errors;
                let errorSchema = schemaValidation.errorSchema;
                const schemaValidationErrors = errors;
                const schemaValidationErrorSchema = errorSchema;
                if (extraErrors) {
                    const merged = schemaUtils.mergeValidationData(schemaValidation, extraErrors);
                    errorSchema = merged.errorSchema;
                    errors = merged.errors;
                    errors = _uniqWith(errors, isErrorEqual);
                }
                state = {
                    formData: newFormData,
                    errors,
                    errorSchema,
                    schemaValidationErrors,
                    schemaValidationErrorSchema,
                };
            }
            else if (!noValidate && newErrorSchema) {
                const errorSchema = extraErrors
                    ? mergeObjects(newErrorSchema, extraErrors, 'preventDuplicates')
                    : newErrorSchema;
                state = {
                    formData: newFormData,
                    errorSchema: errorSchema,
                    errors: schemaUtils.getValidator().toErrorList(errorSchema),
                };
            }
            this.setState(state, () => onChange && onChange(Object.assign(Object.assign({}, this.state), state), id));
        };
        this.reset = () => {
            const { onChange } = this.props;
            const newState = this.getStateFromProps(this.props, undefined);
            const newFormData = newState.formData;
            const state = {
                formData: newFormData,
                errorSchema: {},
                errors: [],
                schemaValidationErrors: [],
                schemaValidationErrorSchema: {},
            };
            this.setState(state, () => onChange && onChange(Object.assign(Object.assign({}, this.state), state)));
        };
        this.onBlur = (id, data) => {
            this.partialValidateForm(id, false);
            const { onBlur } = this.props;
            if (onBlur) {
                onBlur(this.state, id, data);
            }
        };
        /** Front-office begin */
        this.filterErrors = (errors) => {
            let uniqueErrors = _uniqWith(errors, isErrorEqual);
            // TODO use of dependencies generates lot of unnecessary errors
            // once we have if then else capability this workaround can be removed
            // https://github.com/rjsf-team/react-jsonschema-form/pull/1666/files
            uniqueErrors = uniqueErrors.filter(e => !['enum', 'oneOf', 'const', 'if'].includes(e.name));
            if (this.props.translation) {
                uniqueErrors = uniqueErrors.map(e => translateError(this.props.uiSchema, this.props.translation)(e));
            }
            return uniqueErrors;
        };
        this.debouncedPartialValidate = _.debounce((id) => {
            this.partialValidateForm(id, false);
        }, 500);
        if (this.props.onChange) {
            this.props.onChange(this.state);
        }
    }
    validate(formData, schema = this.props.schema, altSchemaUtils, filterErrors) {
        const schemaUtils = altSchemaUtils
            ? altSchemaUtils
            : this.state.schemaUtils;
        const { customValidate, transformErrors, uiSchema } = this.props;
        const resolvedSchema = schemaUtils.retrieveSchema(schema, formData);
        return schemaUtils
            .getValidator()
            .validateFormData(formData, resolvedSchema, customValidate, (errors) => {
            let errs = errors;
            if (filterErrors) {
                errs = filterErrors(errs);
            }
            if (transformErrors) {
                errs = transformErrors(errs);
            }
            errs = this.filterErrors ? this.filterErrors(errs) : errs;
            return errs;
        }, uiSchema);
    }
    /** Returns the registry for the form */
    getRegistry() {
        const superRegistry = super.getRegistry();
        return Object.assign(Object.assign({}, superRegistry), { onChange: this.onChange.bind(this), validate: this.partialValidateForm.bind(this), formGetState: this.getState.bind(this), formSetState: this.setState.bind(this), getFormData: this.getFormData.bind(this), setFormData: this.setFormData.bind(this), onSectionSubmit: this.onSectionSubmit.bind(this), onSectionEdit: this.onSectionEdit.bind(this), onSectionReorder: this.onSectionReorder.bind(this), onSectionDelete: this.onSectionDelete.bind(this), onNewSectionCancel: this.onNewSectionCancel.bind(this), triggerPostProcess: this.triggerPostProcess.bind(this), forceValidityState: this.forceValidityState.bind(this), idPrefix: this.props.idPrefix, idSeparator: this.props.idSeparator });
    }
    getState() {
        return this.state;
    }
    /** Attempts to focus on the field associated with the `error`. Uses the `property` field to compute path of the error
     * field, then, using the `idPrefix` and `idSeparator` converts that path into an id. Then the input element with that
     * id is attempted to be found using the `formElement` ref. If it is located, then it is focused.
     *
     * @param error - The error on which to focus
     */
    focusOnError(error) {
        const field = this.getField(error);
        if (field) {
            field.focus();
        }
    }
    focusOnErrors(errors) {
        const fields = errors
            .map(err => this.getField(err))
            .filter(f => f != null)
            .sort((f1, f2) => {
            if (f1.getBoundingClientRect().top > f2.getBoundingClientRect().top) {
                return 1;
            }
            if (f1.getBoundingClientRect().top < f2.getBoundingClientRect().top) {
                return -1;
            }
            return 0;
        });
        if (fields.length) {
            fields[0].focus();
        }
    }
    getField(error) {
        const { idPrefix = "root", idSeparator = "_" } = this.props;
        const { property } = error;
        const path = _toPath(property);
        if (path[0] === "") {
            // Most of the time the `.foo` property results in the first element being empty, so replace it with the idPrefix
            path[0] = idPrefix;
        }
        else {
            // Otherwise insert the idPrefix into the first location using unshift
            path.unshift(idPrefix);
        }
        const elementId = path.join(idSeparator);
        let field = this.formElement.current.elements[elementId];
        if (!field) {
            // if not an exact match, try finding an input starting with the element id (like radio buttons or checkboxes)
            field = this.formElement.current.querySelector(`input[id^=${elementId}`);
        }
        if (!field) {
            field = document.getElementById(elementId);
        }
        return field;
    }
    getFormData(property) {
        return _get(this.state.formData, property);
    }
    setFormData(propertyFormData, property) {
        const newFormData = _cloneDeep(this.state.formData);
        _set(newFormData, property, propertyFormData);
        const state = {
            formData: newFormData,
        };
        this.setState(state, () => {
            this.props.onChange && this.props.onChange(this.state);
        });
    }
    triggerPostProcess(propertyId, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const property = idToPropertyPath(propertyId, this.props.idPrefix);
            const clonedFormData = _cloneDeep(this.state.formData);
            _set(clonedFormData, property, value);
            const newState = {
                formData: clonedFormData,
            };
            const changeProps = {
                propertyId
            };
            this.onSectionChange(newState, () => {
            }, changeProps);
        });
    }
    onSectionSubmit({ sectionItemFormData, propertyPath, callback, customValidateSuccessHandler, cancelSubmission = false, }) {
        return __awaiter(this, void 0, void 0, function* () {
            // const schemaUtils = this.state.schemaUtils;
            const { idPrefix } = this.props;
            const property = idToPropertyPath(propertyPath, idPrefix);
            const isValid = this.partialValidateForm(propertyPath, true);
            // Error schema requires array indexes to be converted to objects
            const propertySchema = getAsPropertySchema(property);
            let formData;
            // eslint-disable-next-line prefer-const
            ({ formData } = this.state);
            const propertyContext = propertySchema === null || propertySchema === void 0 ? void 0 : propertySchema.substring(0, propertySchema === null || propertySchema === void 0 ? void 0 : propertySchema.lastIndexOf('.'));
            const sectionName = propertyContext === null || propertyContext === void 0 ? void 0 : propertyContext.split('.').pop();
            if (customValidateSuccessHandler != null) {
                customValidateSuccessHandler();
            }
            else if (isValid) {
                formData = _cloneDeep(formData);
                const section = Object.assign({}, sectionItemFormData);
                const sectionArr = _get(formData, propertyContext);
                const confirmedSectionItems = Array.isArray(sectionArr)
                    ? sectionArr.filter(party => party.state === 'CONFIRMED')
                    : [];
                section.state = 'CONFIRMED';
                if (section.sequenceNumber == null) {
                    const lastSequenceNumber = confirmedSectionItems.reduce((sequenceNumber, item) => (item.sequenceNumber > sequenceNumber ? item.sequenceNumber : sequenceNumber), 0);
                    section.sequenceNumber = lastSequenceNumber + 1;
                }
                _set(formData, property, section);
                if (this.props.onSectionSubmit) {
                    try {
                        formData = yield this.props.onSectionSubmit(Object.assign(Object.assign({}, this.state), { formData,
                            sectionItemFormData, prop: propertyPath, sectionName,
                            cancelSubmission }));
                    }
                    catch (err) {
                        // eslint-disable-next-line no-console
                        console.error(err);
                        section.state = null;
                        _set(formData, property, section);
                    }
                }
                const state = {
                    formData,
                };
                const changeProps = {
                    sectionName: sectionName,
                    sectionOperation: cancelSubmission ? OperationType.CANCEL : OperationType.SUBMIT,
                    sectionItemId: sectionItemFormData.id,
                };
                this.onSectionChange(state, callback, changeProps);
            }
        });
    }
    forceValidityState(valid) {
        this.setState({ isInvalid: !valid }, () => { });
    }
    onSectionEdit({ rootSection, sectionName, itemId, callback }) {
        var _a;
        const formData = _cloneDeep(this.state.formData);
        formData[rootSection][sectionName] = (_a = formData[rootSection][sectionName]) === null || _a === void 0 ? void 0 : _a.map(p => p.id === itemId ? _omit(p, 'state') : p);
        const state = {
            formData,
        };
        const sectionChangeProps = {
            sectionName: sectionName,
            sectionOperation: OperationType.EDIT,
            sectionItemId: itemId,
        };
        this.onSectionChange(state, callback, sectionChangeProps);
    }
    onSectionReorder({ propertyPath, formEntities, sectionName, itemId, callback }) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = _cloneDeep(this.state.formData);
            _set(formData, propertyPath, formEntities);
            const state = {
                formData,
            };
            const sectionChangeProps = {
                sectionName,
                sectionOperation: OperationType.ORDER,
                sectionItemId: itemId,
            };
            yield this.onSectionChange(state, callback, sectionChangeProps);
        });
    }
    onSectionDelete({ rootSection, sectionName, itemId, callback }) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let formData = _cloneDeep(this.state.formData);
            if (!formData[rootSection] || !formData[rootSection][sectionName]) {
                console.debug('Section does not exist.');
                return;
            }
            const deletedSequenceNumber = (_a = formData[rootSection][sectionName].find(p => p.id === itemId)) === null || _a === void 0 ? void 0 : _a.sequenceNumber;
            formData[rootSection][sectionName] = formData[rootSection][sectionName].filter(p => p.id !== itemId);
            if (deletedSequenceNumber !== undefined && deletedSequenceNumber !== null) {
                reSequenceFormEntitiesOnDeletion(deletedSequenceNumber, formData[rootSection][sectionName]);
            }
            if (this.props.onSectionDelete) {
                formData = yield this.props.onSectionDelete(Object.assign(Object.assign({}, this.state), { formData,
                    sectionName }));
            }
            const state = {
                formData,
            };
            const changeProps = {
                sectionName,
                sectionOperation: OperationType.DELETE,
                sectionItemId: itemId,
            };
            yield this.onSectionChange(state, callback, changeProps);
        });
    }
    onNewSectionCancel({ propertyPath, callback }) {
        const { formData, errors, errorSchema } = this.state;
        const { idPrefix } = this.props;
        const property = idToPropertyPath(propertyPath, idPrefix);
        const propertySchema = getAsPropertySchema(property);
        const state = {
            formData,
            errorSchema: _omit(_cloneDeep(errorSchema), propertySchema),
            errors: errors.filter(e => { var _a; return !((_a = e.property) === null || _a === void 0 ? void 0 : _a.includes(property)); }),
        };
        this.setState(state, () => {
            // this.props.onStateChange && this.props.onStateChange(this.state);
            callback && callback();
        });
    }
    onSectionChange(state, callback, changeProps) {
        this.setState(state, () => __awaiter(this, void 0, void 0, function* () {
            if (this.props.onSectionChange) {
                this.props.onSectionChange(Object.assign(Object.assign({}, this.state), { changeProps }));
            }
            callback && callback();
        }));
    }
    partialValidateForm(forIdSchema, focusOnError = true) {
        const { extraErrors, focusOnFirstError, onError } = this.props;
        const { formData } = this.state;
        const { schemaUtils } = this.state;
        const idSchemaPath = idToPropertyPath(forIdSchema, this.props.idPrefix, this.props.idSeparator);
        const lodashIdSchemaPath = idSchemaPath === null || idSchemaPath === void 0 ? void 0 : idSchemaPath.replace(/(\[(\d+)\])/g, '.$2'); //idSchemaPath;
        let previousErrors = _cloneDeep(this.state.errors);
        let previousErrorSchema = _cloneDeep(this.state.errorSchema);
        previousErrors = previousErrors.filter((err) => err.property.indexOf(lodashIdSchemaPath) == -1);
        previousErrorSchema = _omit(previousErrorSchema, lodashIdSchemaPath);
        const filterErrors = (errors) => {
            const filtered = errors.filter(err => err.property.indexOf(lodashIdSchemaPath) > -1);
            return filtered;
        };
        const schemaValidation = this.validate(formData, this.props.schema, null, filterErrors);
        let errors = schemaValidation.errors;
        let errorSchema = schemaValidation.errorSchema;
        // store as a backup to focus to the error inside partial
        const partialErrors = _cloneDeep(errors);
        errors = errors.concat(previousErrors);
        errors = _uniqWith(errors, isErrorEqual);
        errorSchema = mergeObjects(previousErrorSchema, errorSchema, 'preventDuplicates');
        if (extraErrors && Object.keys(extraErrors).length) {
            errorSchema = mergeObjects(errorSchema, extraErrors, 'preventDuplicates');
            const merged = schemaUtils.mergeValidationData({ errors, errorSchema }, extraErrors);
            errorSchema = merged.errorSchema;
            errors = merged.errors;
        }
        this.setState({
            errors,
            errorSchema,
            schemaValidationErrors: errors,
            schemaValidationErrorSchema: errorSchema,
        }, () => {
            if (focusOnError && focusOnFirstError && partialErrors) {
                this.focusOnErrors(partialErrors);
            }
            if (onError) {
                onError(errors);
            }
        });
        if (partialErrors.length > 0) {
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=FoForm.js.map